





































































































































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { cloneDeep } from 'lodash';
import { successButtonColorClass } from '@/utlitities/color';
import { UserStore } from '@/store/user-module';

@Component({
  inheritAttrs: false,
  components: {},
})
export default class StSelect extends Vue {
  @Prop() name!: string;
  @Prop() options!: any[];
  @Prop() translateOptions!: boolean;
  @Prop() rules!: string;
  @Prop() value!: any;
  @Prop() inputClass!: string;
  @Prop() labelProp!: string;
  @Prop() idProp!: string;
  @Prop() taggable!: boolean;
  @Prop() placeholder!: string;
  @Prop() clearable!: boolean;
  @Prop() disabled!: boolean;
  @Prop() multiple!: boolean;
  @Prop() valImmediate!: boolean;
  @Prop() grouped!: boolean;
  @Prop({ default: true }) closeOnSelect!: boolean;
  @Prop({ default: false }) hideSearchBox!: boolean;
  @Prop({ default: false }) hideOptions!: boolean;
  @Prop({ default: false }) hideSelectButtonIcon!: boolean;
  @Prop({ default: false }) hideOptGroups!: boolean;
  @Prop({ default: false }) openOnMounted!: boolean;
  @Prop() searchBoxPlaceholder!: string;
  @Prop() placeholderClass!: string;
  @Prop() labelIcon!: string;
  @Prop() isProjectSelect!: boolean;

  delayedValueWatch: any;
  delayedValue: any = null;

  async mounted() {
    if (this.multiple) {
      setTimeout(() => {
        this.delayedValue = this.value;
      }, 500);

      this.delayedValueWatch = this.$watch(
        'value',
        () => {
          this.delayedValue = this.value;
        },
        { deep: true }
      );
    }

    if (this.openOnMounted) {
      this.open();
    }
  }

  get hideSearchBoxProp() {
    return this.hideSearchBox || window.innerWidth < 768;
  }

  beforeDestroy() {
    if (this.delayedValueWatch) {
      this.delayedValueWatch();
    }
  }

  get successButtonColor() {
    return successButtonColorClass(UserStore.userSettings.successButtonColor);
  }

  get selectedValue() {
    if (this.multiple) {
      return this.delayedValue;
    }
    return this.value;
  }

  get lowOptionsNumber() {
    return (this.options?.length ?? 0) <= 5;
  }

  get getSearchBoxPlaceholder() {
    return this.searchBoxPlaceholder ?? this.$t('Suchen ...');
  }

  getIsDummyCustomerProjectForComponent(option: any){
    if(!this.isProjectSelect){
      return false;
    }

    return ((option?.raw?.items) as any[])?.length == 1 && option?.raw?.groupName == ((option?.raw?.items) as any[])[0]?.description;
  }

  getIsDummyCustomerProject(option: any){
    return this.isProjectSelect && ((option.items || option.childItems) as any[]).length == 1 && ((option.items || option.childItems) as any[])[0][this.labelProp || 'description'] == option.groupName;
  }

  get getOptions() {
    let options = this.options;
    // Options is array of strings or numbers
    if (!!options[0] && ['string', 'number'].indexOf(typeof options[0]) !== -1) {
      if (this.translateOptions) {
        return options.map((o) => {
          return {
            value: o,
            text: this.$t(o),
          };
        });
      }
      return options.map((x) => {
        return {
          value: x,
          text: x,
        };
      });
    }

    // prepare object field names for grouped select
    if (this.grouped) {
      options = options.map((x) => {
        if(this.getIsDummyCustomerProject(x)){
          x = { ...x };
          x.text = 'Direktbuchungskunde';
          x.children = ((x.items || x.childItems) as any[]).map((x) => {
            x = { ...x };
            x.text = x[this.labelProp || 'description'];
            x.value = x[this.idProp || 'value'];
            return x;
          });
          return x;
        }else{
          x = { ...x };
          x.text = x.groupName;
          x.children = ((x.items || x.childItems) as any[]).map((x) => {
            x = { ...x };
            x.text = x[this.labelProp || 'description'];
            x.value = x[this.idProp || 'value'];
            return x;
          });
          return x;
        }
        return x;
      });
      // if this is not a grouped select, remap labelProp and idProp
    } else if (this.labelProp !== 'text' && this.idProp !== 'value') {
      options = options.map((x) => {
        x = { ...x };
        x.text = x[this.labelProp || 'description'];
        x.value = x[this.idProp || 'value'];
        return x;
      });
    }

    if (!this.translateOptions) {
      return options;
    }
    //translate options
    return options.map((x) => {
      x.text = this.$t(x[this.labelProp || 'description']);
      return x;
    });
  }

  open() {
    //@ts-ignore
    this.$refs.trichselect.$el.getElementsByClassName('clickme')[0].click();
  }

  blur() {
    //@ts-ignore
    this.$refs['adsas'].validate();
  }

  reduceFunc(option: any) {
    if (!!this.idProp && !!option) {
      return option[this.idProp];
    }
    return option;
  }

  getSearchOptions(query: string) {
    this.$emit('search', query);

    let options = cloneDeep(this.getOptions);

    options.forEach((opt) => {
      //if option (or group) matches
      if (opt.text.toLowerCase().indexOf(query.toLowerCase()) != -1) {
        opt.groupMatch = true;
      }

      //if option has children
      if (opt.children && opt.children.length && opt.children.filter((child: any) => child.text.toLowerCase().indexOf(query.toLowerCase()) != -1).length) {
        opt.isMatch = true;

        //mark children as match
        opt.children.forEach((child: any) => {
          child.isMatch = child.text.toLowerCase().indexOf(query.toLowerCase()) != -1;
        });
      }
    });

    //filter by matches
    options = options.filter((opt) => opt.groupMatch == true || opt.isMatch == true);

    options.forEach((opt) => {
      if (opt.children && opt.children.length) {
        if (opt.isMatch && !opt.groupMatch) {
          opt.children = opt.children.filter((_: any) => _.isMatch);
        }
      }
    });

    return { results: options };
  }

  fetchError(err: any) {}

  deselect(optionIndex: any) {
    (this.$refs.trichselect as any).unselectOptionAtIndex(optionIndex);
  }

  getParentName(child: any) {
    const parent = this.options.find((option) => {
      return (
        (option.items || option.childItems)?.length &&
        !!((option.items || option.childItems) as any[]).find((c) => {
          return c[this.idProp || 'id'] === child.value;
        })
      );
    });
    const res = parent ? parent.groupName : '';

    if(this.getIsDummyCustomerProject(parent)){
      return 'Direktbuchungskunde';
    }

    return res;
  }

  @Emit('input')
  input(value: any) {
    return this.reduceFunc(value);
  }
}
